import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback } from 'react'

import { NumberInput } from 'cng-common/components/numberInput'
import { Translation } from 'cng-common/features/translations'
import { updateAssortmentGroup } from 'partner360/features/assortment/assortmentSlice'
import { IAssortmentGroup } from 'partner360/features/assortment/models/data/IAssortmentGroup'

import { TRANSLATION_KEYS } from '../../../../translations'

import styles from './GroupDetails.module.scss'

interface IGroupDetailsProps {
  isEditMode: boolean
  group: IAssortmentGroup
  // businessPercentage: number
  // unitsCount: number
}

export const GroupDetails: FC<IGroupDetailsProps> = ({ isEditMode, group }) => {
  const dispatch = useAppDispatch()

  const changeBusinessPercentage = useCallback(
    (buisnessPercentage: number) => {
      dispatch(
        updateAssortmentGroup({
          ...group,
          BusinessPercentage: isNaN(buisnessPercentage) ? 0 : buisnessPercentage,
        })
      )
    },
    [dispatch, group]
  )

  const changeUnitsCount = useCallback(
    (unitsCount: number) => {
      dispatch(
        updateAssortmentGroup({
          ...group,
          UnitsCount: unitsCount,
        })
      )
    },
    [dispatch, group]
  )

  if (isEditMode) {
    return (
      <div className={styles.root}>
        <NumberInput
          label={<Translation text={TRANSLATION_KEYS.group.businessPercentageLabel} />}
          min={0}
          max={100}
          value={group.BusinessPercentage.toString()}
          onChange={(value) => changeBusinessPercentage(parseFloat(value))}
        />
        <NumberInput
          label={<Translation text={TRANSLATION_KEYS.group.unitsCountLabel} />}
          value={group.UnitsCount.toString()}
          onChange={(value) => changeUnitsCount(parseFloat(value))}
        />
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <Translation
        span
        text={TRANSLATION_KEYS.group.buisnessPercentage}
        replaceParams={[
          {
            key: '{businessPercentage}',
            value: group.BusinessPercentage.toString(),
          },
        ]}
      />
      <Translation
        span
        text={TRANSLATION_KEYS.group.unitsCount}
        replaceParams={[
          {
            key: '{unitsCount}',
            value: group.UnitsCount.toString(),
          },
        ]}
      />
    </div>
  )
}
